import React from 'react';
import ReactDOM from 'react-dom/client';
import "./styles/main.scss"
import Routers from './routers/index';
import store from './store';
import { Provider } from 'react-redux';
import ToastComponent from './components/Toast';
import 'aos/dist/aos.css';
import AOS from 'aos';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
AOS.init({
	easing: 'ease-in-out',
	duration: 500,
	once: false,
	mirror: true,
});
root.render(
  <Provider store={store}>
    <ToastComponent />
   
    <Routers />
  </Provider>
);

